import React from 'react';

import './LogoSoac.css';

/**
 * Logo do SOAC — proposta "Porca" (escolhida pelo Victor em 23/10/2026, at-130).
 *
 * "S" + porca sextavada laranja no lugar do "O" + "AC". O furo da porca usa `corDoFundo`, para
 * a marca funcionar em fundo claro e escuro (o telão tem os dois temas).
 *
 * A marca da EMPRESA continua sendo a da Atual (sidebar, login): o SOAC é o sistema.
 */
interface LogoSoacProps {
  /** Altura das letras, em px. A porca acompanha. */
  tamanho?: number;
  /** Cor do furo da porca — a do fundo onde a logo está. */
  corDoFundo?: string;
  /** Cor da porca. Laranja por padrão; sobre fundo laranja (login), branca. */
  corDaPorca?: string;
  className?: string;
}

export const PorcaSoac: React.FC<{ tamanho: number; corDoFundo?: string; corDaPorca?: string }> = ({
  tamanho,
  corDoFundo = '#ffffff',
  corDaPorca = '#ea5d0e',
}) => (
  <svg width={tamanho} height={tamanho} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
    <path d="M24 2 L43 13 V35 L24 46 L5 35 V13 Z" fill={corDaPorca} />
    <circle cx="24" cy="24" r="9" fill={corDoFundo} />
  </svg>
);

const LogoSoac: React.FC<LogoSoacProps> = ({ tamanho = 28, corDoFundo = '#ffffff', corDaPorca, className }) => (
  <span
    className={`logo-soac${className ? ` ${className}` : ''}`}
    style={{ fontSize: tamanho }}
    role="img"
    aria-label="SOAC"
  >
    <span aria-hidden="true">S</span>
    <PorcaSoac tamanho={Math.round(tamanho * 0.92)} corDoFundo={corDoFundo} corDaPorca={corDaPorca} />
    <span aria-hidden="true">AC</span>
  </span>
);

export default LogoSoac;
